<template>
  <div class="travel-list-page">
    <div class="travel-list-container">
      <tr-tabs @tabClick="tabClick"
               :activeName="activeName">
        <tr-tabs-panel label="我的草稿"
                       name="draft">
          <div class="travels-content">
            <div class="travels-item"
                 v-for="(item, index) in draftList"
                 :key="index">
              <tr-item :imageUrl="item.imgs"
                       :item="item"
                       :visitPath="
                  item.state === 0 || item.state === 3
                    ? `/detail/old${item.id}`
                    : `/traveling/${item.id}`
                ">
                <div class="travels-info-wrap">
                  <div class="travels-info-item">
                    <div class="travel-title-wrap">
                      <a class="travel-title"
                         target="_blank"
                         :href="
                          item.state === 0 || item.state === 3
                            ? `/detail/old${item.id}`
                            : `/traveling/${item.id}`
                        ">{{
                          item.name.length > 25
                            ? `${item.name.slice(0, 25)}...`
                            : item.name
                        }}</a>
                      <span class="travel-tag"
                            v-if="item.playDays">{{ item.playDays }}日游</span>
                    </div>
                    <p class="travel-path">
                      发布于 {{ item.updateTime | formatDate }}
                    </p>
                    <!-- <p class="travel-status">
                      <template v-if="item.state === 0">
                        <span class="release-success"> <i></i>已发布 </span>
                      </template>
                      <template v-if="item.state === 2">
                        <span class="releasing"> <i></i>保存中 </span>
                      </template>
                      <template v-if="item.state === 1">
                        <span class="releasing"> <i></i>审核中 </span>
                      </template>
                      <template v-if="item.state === 4">
                        <span class="release-failed"> <i></i>发布失败 </span>
                        <el-popover
                          placement="top-start"
                          title="发布失败理由"
                          width="500"
                          trigger="hover"
                          :content="item.remarks"
                        >
                          <span slot="reference" class="release-failed-context"
                            >发布失败理由:{{ item.remarks }}</span
                          >
                        </el-popover>
                      </template>
                    </p> -->
                  </div>
                  <div class="travels-info-bottom">
                    <div class="travel-experience-wrap">
                      <span class="mark-item">
                        <img src="~@/assets/images/icons/icon-drive-difficulty.png" />&nbsp;
                        <span>驾驶难度：{{ item.difficulty | getdifficulty }}</span>
                      </span>
                      <span class="mark-item">
                        <img src="~@/assets/images/icons/total-mileage-colorful.png" />
                        &nbsp;总里程：{{
                          item.totalMileage ? `${item.totalMileage}公里` : "--"
                        }}
                      </span>
                      <span class="mark-item">
                        <img src="~@/assets/images/icons/icon-money.png" />
                        &nbsp;人均消费：{{ item.price ? `${item.price}元` : "--" }}
                      </span>
                    </div>
                  </div>
                  <div class="travel-operation-bar">
                    <span @click="previewFunc(item)"></span>
                    <span @click="deleteFunc(item)"></span>
                  </div>
                </div>
              </tr-item>
            </div>
          </div>
          <!-- 超过10P可通过下方控件分页查看 -->
          <div class="travel-page-bar"
               v-if="draftListTotal > 10 || page > 1">
            <el-pagination background
                           layout="prev, pager, next"
                           :current-page="unsavedata.page"
                           :total="draftListTotal"
                           @current-change="handleCurrentChange1"></el-pagination>
          </div>
          <div v-else>
            -已经到底啦-
          </div>
          <div class="no-search-result"
               v-if="travelListTotal === 0">
            <div class="no-search-image"></div>
            <div class="no-search-tip">你看这里空空的，急需你的一篇游记~</div>
          </div>
        </tr-tabs-panel>
        <tr-tabs-panel label="我的游记"
                       name="travel">
          <div class="travels-content">
            <div class="travels-item"
                 v-for="(item, index) in travelList"
                 :key="index">
              <tr-item :imageUrl="item.imgs"
                       :item="item"
                       :visitPath="
                  item.state === 0 || item.state === 3
                    ? `/detail/old${item.id}`
                    : `/traveling/${item.id}`
                ">
                <div class="travels-info-wrap">
                  <div class="travels-info-item">
                    <div class="travel-title-wrap">
                      <a class="travel-title"
                         target="_blank"
                         :href="
                          item.state === 0 || item.state === 3
                            ? `/detail/old${item.id}`
                            : `/traveling/${item.id}`
                        ">{{
                          item.name.length > 25
                            ? `${item.name.slice(0, 25)}...`
                            : item.name
                        }}</a>
                      <span class="travel-tag"
                            v-if="item.playDays">{{ item.playDays }}日游</span>
                    </div>
                    <p class="travel-path">
                      发布于 {{ item.updateTime | formatDate }}
                    </p>
                    <!-- <p class="travel-status">
                      <template v-if="item.state === 0">
                        <span class="release-success"> <i></i>已发布 </span>
                      </template>
                      <template v-if="item.state === 2">
                        <span class="releasing"> <i></i>保存中 </span>
                      </template>
                      <template v-if="item.state === 1">
                        <span class="releasing"> <i></i>审核中 </span>
                      </template>
                      <template v-if="item.state === 4">
                        <span class="release-failed"> <i></i>发布失败 </span>
                        <el-popover
                          placement="top-start"
                          title="发布失败理由"
                          width="500"
                          trigger="hover"
                          :content="item.remarks"
                        >
                          <span slot="reference" class="release-failed-context"
                            >发布失败理由:{{ item.remarks }}</span
                          >
                        </el-popover>
                      </template>
                    </p> -->
                  </div>
                  <div class="travels-info-bottom">
                    <div class="travel-experience-wrap">
                      <span class="mark-item">
                        <img src="~@/assets/images/icons/icon-drive-difficulty.png" />&nbsp;
                        <span>驾驶难度：{{ item.difficulty | getdifficulty }}</span>
                      </span>
                      <span class="mark-item">
                        <img src="~@/assets/images/icons/total-mileage-colorful.png" />
                        &nbsp;总里程：{{
                          item.totalMileage ? `${item.totalMileage}公里` : "--"
                        }}
                      </span>
                      <span class="mark-item">
                        <img src="~@/assets/images/icons/icon-money.png" />
                        &nbsp;人均消费：{{ item.price ? `${item.price}元` : "--" }}
                      </span>
                    </div>
                  </div>
                  <div class="travel-operation-bar">
                    <span @click="previewFunc(item)"></span>
                    <span @click="deleteFunc(item)"></span>
                  </div>
                </div>
              </tr-item>
            </div>
          </div>
          <!-- 超过10P可通过下方控件分页查看 -->
          <div class="travel-page-bar"
               v-if="travelListTotal > 10 || page > 1">
            <el-pagination background
                           layout="prev, pager, next"
                           :current-page="traveldata.page"
                           :total="travelListTotal"
                           @current-change="handleCurrentChange2"></el-pagination>
          </div>
          <div v-if="travelListTotal > 0 && travelListTotal <= 10">
            -已经到底啦-
          </div>
          <div class="no-search-result"
               v-if="travelListTotal === 0">
            <div class="no-search-image"></div>
            <div class="no-search-tip">你看这里空空的，急需你的一篇游记~</div>
          </div>
        </tr-tabs-panel>
        <tr-tabs-panel label="我的评论"
                       name="comment">
          <div class="travels-content">
            <div class="comment-item"
                 v-for="(item, index) in commentList"
                 :key="`${index}comment`">
              <!-- 我的评论 -->
              <mine-comment :item="item"
                            :commentTitle="item.dataName"
                            :commentContent="item.comment"
                            :commentDate="
                  item.createTime.substring(0, item.createTime.length - 3)
                "
                            :commentLikeNumber="item.adoptNum"
                            :commentIsLike="Boolean(item.ownAdoptFlag)"
                            @toggleLike="changeLike(item)"
                            @deleteComment="deleteComment(item)">
              </mine-comment>
            </div>
          </div>
          <div class="travel-page-bar"
               v-if="commentListTotal > 10 || page > 1">
            <el-pagination background
                           layout="prev, pager, next"
                           :current-page="commentData.page"
                           :total="commentListTotal"
                           @current-change="handleCurrentChange4"></el-pagination>
          </div>
          <div v-if="commentListTotal > 0 && commentListTotal <= 10">
            -已经到底啦-
          </div>
          <div class="no-search-result"
               v-if="commentListTotal === 0">
            <div class="no-search-image"></div>
            <div class="no-search-tip">
              评论区还欠你一个热门，此处还需一条评论。
            </div>
          </div>
        </tr-tabs-panel>
        <tr-tabs-panel label="我想去"
                       name="want">
          <div class="travels-content">
            <div class="travels-item"
                 v-for="(item, index) in wantList"
                 :key="index">
              <tr-item :imageUrl="item.imgs"
                       :item="item"
                       :visitPath="`/detail/old${item.id}`">
                <div class="travels-info-wrap">
                  <div class="travels-info-item">
                    <div class="travel-title-wrap">
                      <a class="travel-title"
                         target="_blank"
                         :href="`/detail/old${item.id}`">{{ item.name }}</a>
                      <span class="travel-tag"
                            v-if="item.playDays">{{ item.playDays }}日游</span>
                    </div>
                    <p class="travel-path"
                       :title="item.infoParagraphName">
                      {{
                        item.infoParagraphName &&
                        item.infoParagraphName.length > 50
                          ? `${item.infoParagraphName.slice(0, 50)}...`
                          : item.infoParagraphName
                      }}
                    </p>
                    <p class="travel-mark">
                      <span>发表时间：{{ item.createTime | createTimeFilter }}</span>
                      <span>
                        <i class="el-icon-user-solid"></i>
                        &nbsp;用户：{{
                          item.nickName ? item.nickName : `用户${item.userId}`
                        }}
                      </span>
                    </p>
                  </div>
                  <div class="travels-info-bottom">
                    <div class="travel-experience-wrap">
                      <span class="mark-item">
                        <img src="~@/assets/images/icons/icon-drive-difficulty.png" />&nbsp;
                        <span>驾驶难度：{{ item.difficulty | getdifficulty }}</span>
                      </span>
                      <span class="mark-item">
                        <img src="~@/assets/images/icons/total-mileage-colorful.png" />
                        &nbsp;总里程：
                        {{
                          item.totalMileage ? `${item.totalMileage}公里` : "--"
                        }}
                      </span>
                      <span class="mark-item">
                        <img src="~@/assets/images/icons/icon-money.png" />
                        &nbsp;人均消费：{{ item.price ? `${item.price}元` : "--" }}
                      </span>
                    </div>
                  </div>
                  <div class="travel-operation-bar-other">
                    <span @click="deleteWantGoFunc(item)"></span>
                  </div>
                </div>
              </tr-item>
            </div>
          </div>
          <div class="travel-page-bar"
               v-if="wantListTotal > 10 || page > 1">
            <el-pagination background
                           layout="prev, pager, next"
                           :current-page="wantdata.page"
                           :total="wantListTotal"
                           @current-change="handleCurrentChange3"></el-pagination>
          </div>
          <div v-if="wantListTotal > 0 && wantListTotal <= 10">
            -已经到底啦-
          </div>
          <div class="no-search-result"
               v-if="wantListTotal === 0">
            <div class="no-search-image"></div>
            <div class="no-search-tip">
              将向往一一收录，总会一一到达，去<span class="search-notes"
                    @click="findNotes">寻找</span>吧
            </div>
          </div>
        </tr-tabs-panel>
      </tr-tabs>
    </div>
  </div>
</template>
<script>
import TrItem from "@/components/travels/TrItem";
import TrTabs from "@/components/layout/TrTabs";
import TrTabsPanel from "@/components/layout/TrTabsPanel";
import url from "@/assets/recommend/main-image.jpg";
import { mapState, mapActions, mapMutations } from "vuex";
import { commonFilter } from "../Travel/commonFilter.js";
import MineComment from "@/components/comment/MineComment";
import {
  getOwnComment,
  adoptComment,
  removeComment
} from "@/axios/service/travel";
import { TravelList, WantList } from "@/axios/service/travel.js";
// import api from "../../axios/api";
export default {
  components: {
    TrItem,
    TrTabs,
    TrTabsPanel,
    MineComment
  },
  computed: {
    ...mapState("PersonalStore", [
      "wantList",
      "travelList",
      "draftList",
      "draftListTotal",
      "travelListTotal",
      "wantListTotal"
    ])
  },
  filters: {
    createTimeFilter (value) {
      return value.substring(0, 10)
    }
  },
  data () {
    return {
      message: "123123123123",
      imgUrl: url,
      page: 1,
      rows: 10,
      activeName: "unsave",
      //我的草稿
      unsavedata: {
        dataType: 14,
        flag: 1,
        userId: this.$cookie.get("userInfo_userId"),
        page: 1,
        rows: 10,
        states: "2"
      },
      //我的游记
      traveldata: {
        dataType: 14,
        flag: 1,
        userId: this.$cookie.get("userInfo_userId"),
        page: 1,
        rows: 10,
        states: "0,1,3,4,5,98,99,100"
      },
      //我想去
      wantdata: {
        userId: this.$cookie.get("userInfo_userId"),
        page: 1,
        rows: 10
      },
      commentData: {
        rows: 10,
        page: 1,
        userId: this.$cookie.get("userInfo_userId")
      },
      //评论列表
      commentList: [],
      commentListTotal: 0
    };
  },
  created () {
    if (this.$route.params.type) {
      this.activeName = this.$route.params.type;
      if (this.activeName === "travel") {
        this.findTravelList(this.traveldata);
      } else if (this.activeName === "want") {
        this.findWantList(this.wantdata);
      } else if (this.activeName === "comment") {
        // 查询评论数据
        this.findCommentList();
      }
    }
  },
  mounted () {
    this.$eventHub.$on("typeChange", data => {
      if (this.activeName !== data) {
        this.activeName = data;
        if (this.activeName === "travel") {
          this.findTravelList(this.traveldata);
        } else if (this.activeName === "want") {
          this.findWantList(this.wantdata);
        } else if (this.activeName === "comment") {
          //查询评论数据
          this.findCommentList();
        }
      }
    });
  },
  methods: {
    //跳转到最新游记页面
    findNotes () {
      this.$router.push({ name: "newTravel" });
    },
    findWantList (params) {
      let that = this;
      WantList(params).then(json => {
        if (json.respCode === 100 && json.result !== undefined) {
          this.wantListMutations(
            json.result.length === 0 ? [] : json.result[0].data
          );
          this.wantListTotalMutations(
            json.result.length === 0 ? 0 : json.result[0].num
          );
          //本次查询没有数据并且当前的页码大于1，需要回到前一页
          if (json.result.length === 0 && that.wantdata.page > 1) {
            that.wantdata.page--;
            that.findWantList(that.wantdata);
          }
        } else {
          // Global.messageErr('获取列表失败');
        }
      });
    },
    //查询评论列表
    findCommentList () {
      let that = this;
      getOwnComment(this.commentData).then(json => {
        if (json.respCode === 100) {
          that.commentListTotal = json.total;
          that.commentList = json.data;
          //本次查询没有数据并且当前的页码大于1，需要回到前一页
          if (json.data.length === 0 && that.commentData.page > 1) {
            that.commentData.page--;
            this.findCommentList();
          }
        }
      });
    },
    //改变是否点赞
    changeLike (item) {
      adoptComment({
        userId: this.$cookie.get("userInfo_userId"),
        commentId: item.id
      }).then(json => {
        //返回后查询所有数据
        if (json.respCode === 100) {
          //刷新我的评论
          this.findCommentList();
        }
      });
    },
    deleteComment (item) {
      this.$confirm("如此优秀的评论，确认删除吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      })
        .then(() => {
          //删除以及删除后刷新列表
          removeComment({
            userId: this.$cookie.get("userInfo_userId"),
            id: item.id
          }).then(json => {
            if (json.respCode === 100) {
              //查询我的评论列表
              this.findCommentList();
            }
          });
        })
        .catch(() => { });
    },
    ...mapMutations("PersonalStore", [
      "travelListMutations",
      "travelListTotalMutations",
      "wantListMutations",
      "wantListTotalMutations"
    ]),
    ...mapMutations("HomeDataStore", ["formMutations"]),
    ...mapActions("NewTravelStore", ["getnewTravelsList"]),
    ...mapActions("NewTravelStore", ["findtrevelNotesdetail"]),
    ...mapActions("PersonalStore", ["findDraftList", "getdeleteTravel"]),
    ...mapActions("CheckDataStore", ["getDeleteWantGo"]),
    handleCurrentChange1 (page) {
      this.unsavedata.page = page;
      this.findDraftList(this.unsavedata);
    },
    handleCurrentChange2 (page) {
      this.traveldata.page = page;
      this.findTravelList(this.traveldata);
    },
    handleCurrentChange3 (page) {
      this.wantdata.page = page;
      this.findWantList(this.wantdata);
    },
    //获取我的评论（分页）
    handleCurrentChange4 (page) {
      this.commentData.page = page;
      this.findCommentList();
    },
    //查看界面
    detailFunction1 (item) {
      this.findtrevelNotesdetail({ id: item.id });
      this.$router.push({ name: "traveling" });
      // this.findtrevelNotesdetail({ id: item.id });
      // this.$router.push({ name: "detail" });
    },
    detailFunction2 (item) {
      if (item.state == 0 || item.state == 3) {
        //审核中、已发布状态游记，点击封面、标题、编辑button-跳转查看页
        let routeUrl = this.$router.resolve({
          path: `/detail/new${item.id}`
        });
        window.open(routeUrl.href, "_blank");
        // this.$router.push({ path: `/detail/${item.id}` });
      } else {
        //已保存、已驳回状态游记，点击封面、标题、编辑button-跳转编辑页
        // this.$router.push({ path: `/traveling/${item.id}` });
        let routeUrl = this.$router.resolve({
          path: `/traveling/${item.id}`
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    detailFunction3 (item) {
      // window.localStorage.setItem("id", item.id);
      let routeUrl = this.$router.resolve({
        path: `/detail/new${item.id}`
      });
      window.open(routeUrl.href, "_blank");
      // this.$router.push({ path: `/detail/${item.id}` });
    },
    //编辑界面
    previewFunc (item) {
      this.findtrevelNotesdetail({ id: item.id });
      let routeUrl = this.$router.resolve({
        path: `/traveling/${item.id}`
      });
      window.open(routeUrl.href, "_blank");
      // this.$router.push({ path: `/traveling/${item.id}` });
    },
    // 删除我想去
    deleteWantGoFunc (item) {
      this.$confirm("此操作将删除该游记, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          // 删除我想去数据
          this.getDeleteWantGo({
            data: [
              {
                userId: this.$cookie.get("userInfo_userId"),
                dataId: item.id,
                dataTypeId: 14,
                fromPage: "my-travel",
                vueParam: this
              }
            ]
          });
          // 删除我想去之后重新查询我想去列表  在store里面
        })
        .catch(() => { });
    },
    findTravelList (params) {
      TravelList(params).then(json => {
        if (json.respCode === 100 && json.data !== undefined) {
          this.travelListMutations(json.data.data);
          this.travelListTotalMutations(json.data.total);
          //本次查询没有数据并且当前的页码大于1，需要回到前一页
          if (json.data.data.length === 0 && this.traveldata.page > 1) {
            this.traveldata.page--;
            this.findTravelList(this.traveldata);
          }
        } else {
          // Global.messageErr('获取列表失败');
        }
      });
    },
    deleteFunc (item) {
      this.$confirm("此操作将删除该游记, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          this.getdeleteTravel({
            dataType: 14,
            dataId: item.id,
            state: item.state,
            // unsavedata: this.unsavedata,
            // traveldata: this.traveldata
          }).then(json => {
            if (json.respCode === 100) {
              this.$Global.messageSuc("删除成功");
              if (item.state === 2) {
                this.findDraftList(this.unsavedata);
              } else if (item.state === 0 || item.state === 1) {
                this.findTravelList(this.traveldata);
              }
            } else {
              this.$Global.messageErr("删除失败");
            }
          });
          //删除之后重新查询的操作写在store中
        })
        .catch(() => { });
    },
    tabClick (tab) {
      if (tab.name === "want") {
        this.findWantList(this.wantdata);
      } else if (tab.name === "draft") {
        this.findTravelList(this.unsavedata);
      } else if (tab.name === "travel") {
        this.findTravelList(this.traveldata);
      } else if (tab.name === "unsave") {
        this.findDraftList(this.unsavedata);
      } else if (tab.name === "comment") {
        //查询我的评论
        this.findCommentList();
      }
    }
  },
  mixins: [commonFilter]
};
</script>
<style lang="less" scoped>
@import "~@/lesses/main/travel/travel-list.less";
@import "~@/lesses/main/personal/mine.less";
</style>
